import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";

// Custom Component
// import {oceanBlueColor, grayColor, blackColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import FullScreenDialog from "../Dialog/FullScreenDialog";
import TabMenu from "../TabMenu/TabMenu";

import UploadDrawingForm from "./UploadDrawingForm";
import Unpublish from "./Unpublish";
import UnpublishDetail from "./UnpublishDetail";

// Custom Style
import createDrawingStyle from "../../styles/jss/components/drawingRegister/createDrawingStyle";

// Fetch Data
// import {getUnpublishPacks} from '../../dataSource/drawingRegister'

const useStyles = makeStyles((theme) => createDrawingStyle(theme));

const CreateDrawing = (props) => {
  const {} = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  // Redux Data
  // const unpublishPacksRedux = useSelector(state => state.unpublishPacksRedux)

  // State Variable
  const [unpublishSeq, setUnpublishSeq] = useState(0);
  const [refashUnpublishRecord, setRefashUnpublishRecord] = useState("");

  // Dialog Contral
  const [unpublishDetailDialogOpen, setUnpublisDetailhDialogOpen] =
    useState(false);

  // Dialog open and close contral
  const unpublishDetailDialogHandleOpen = (unpublishSeq) => {
    setUnpublishSeq(unpublishSeq);
    setUnpublisDetailhDialogOpen(true);
  };

  const unpublishDetailDialogHandleClose = () => {
    dispatch({
      type: "ADD_IMPORT_FILE",
      data: null,
    });
    setUnpublisDetailhDialogOpen(false);
  };

  // Define Tabmenu
  const tabMenuProperty = [
    {
      tabIndex: 0,
      name: "Un-Publish",
      form: (
        <Unpublish
          openUnpublishDetail={unpublishDetailDialogHandleOpen}
          refashUnpublishRecord={refashUnpublishRecord}
        />
      ),
    },
    {
      tabIndex: 1,
      name: "Upload Drawing",
      form: (
        <UploadDrawingForm
          openUnpublishDetail={unpublishDetailDialogHandleOpen}
        />
      ),
    },
  ];

  // Dialog button declaration
  const unpublishDialogBtn = [
    // {
    // 	buttonName: "Annotation Publish",
    // 	buttonFunction: annotationPublishActionHandleOpen,
    // 	chooseFile: false
    // },
  ];

  useEffect(() => {}, []);

  return (
    // console.log("Unpublish Seq. | Variable: unpublishSeq (CreateDrawing.js)"),
    // console.log(unpublishSeq),

    // console.log("Unpublish Packs Data (Redux) | Variable: unpublishPacksRedux (unpublished.js)"),
    // console.log(unpublishPacksRedux),

    // console.log("---------------------------------------------------------------------------------"),

    <Fragment>
      <div>
        <FullScreenDialog
          open={unpublishDetailDialogOpen}
          dialogTitle={"Un-Publish Detail"}
          formContent={
            <UnpublishDetail
              unpublishSeq={unpublishSeq}
              setRefashUnpublishRecord={setRefashUnpublishRecord}
              closeUnpublishDetail={unpublishDetailDialogHandleClose}
            />
          }
          button={unpublishDialogBtn}
          handleClose={unpublishDetailDialogHandleClose}
        />
      </div>

      <TabMenu type="secord" property={tabMenuProperty} defaultTabValue={0} />
    </Fragment>
  );
};

export default CreateDrawing;
